import { fetchFinance } from "utils/api";

export const queryList = async (params) => {
  return await fetchFinance("/settlement/list", {
    type: "edited",
    sort: "tran_date,desc",
    ...params,
  });
};
